import { Popover, PopoverTrigger } from '@/components/ui/popover/popover.component';

// import { T } from '@/components/i18n/message.i18n.component';
// import { cn } from '@/lib/utils';
// import { loginPageMessages } from '@/pages/login/login.messages';
import { useState } from 'react';
// import Markdown from 'react-markdown';
// import CHANGELOG from '../../../../CHANGELOG.MD?raw';
import packageJson from '../../../../package.json';

// import { removeInternalLines } from './app-version.utils';

export const AppVersion = () => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = () => {
    setOpen(!open);
  };

  return (
    <Popover onOpenChange={handleOpenChange}>
      <PopoverTrigger data-testid="app-version-changelog-trigger">
        <div className="bg-light-gray rounded">
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <p data-testid="app-version-number" className="typo-secondary px-2 py-1">
            v{packageJson.version}
          </p>
        </div>
      </PopoverTrigger>
      {/* <PopoverContent
        data-testid="app-version-changelog-content"
        className={cn(
          '[&>ul>li]:mb-2 [&>ul>li]:list-disc [&>ul>li]:ml-4',
          'h-[360px] w-[600px] overflow-scroll [&>h1]:mb-1 [&>h2]:mb-2',
          'flex flex-col space-y-2',
        )}
      >
        {!CHANGELOG && (
          <div className="flex flex-1 justify-center items-center">
            <p>
              <T {...loginPageMessages.changelogError} />
            </p>
          </div>
        )}
        {CHANGELOG && <Markdown>{removeInternalLines(CHANGELOG)}</Markdown>}
      </PopoverContent> */}
    </Popover>
  );
};
